import { render, staticRenderFns } from "./tzz_gm_sz_cs_fa.vue?vue&type=template&id=4bb28f00&scoped=true"
import script from "./tzz_gm_sz_cs_fa.vue?vue&type=script&lang=js"
export * from "./tzz_gm_sz_cs_fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb28f00",
  null
  
)

export default component.exports